/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MarketSpecification {
    All = 'All Markets',
    NoNYChiLA = 'All Markets (No NY/CHI/LA)',
    NoMajor = 'No Major Markets',
    NYOnly = 'NY Only',
    LAOrChicago = 'LA Or Chicago Only',
    TwoOfLANYChicago = '2 Of LA, NY, Chicago',
    LANYAndChicago = 'LA, NY, And Chicago',
    WithNY = 'With NY',
    WithoutNY = 'Without NY',
}
